import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const routes = [{
    path: "/",
    redirect: "/index"
  },{
    path: "/home",
    name: "home",
    component: () => import("@/views/home"),//首页
  },
  {
    path: "/index",
    name: "index",
    component: () => import("@/views/index"),//首页
  },
  {
    path: "/mine",
    name: "mine",
    component: () => import("@/views/mine"),//我的
  },
  {
    path: "/bookList",
    name: "bookList",
    component: () => import("@/views/bookList"),//预约列表
  },
   {
    path: "/bookList2",
    name: "bookList2",
    component: () => import("@/views/bookList2"),//预约列表
  },
  {
    path: "/info",
    name: "info",
    component: () => import("@/views/info"),//预约详情
  }
];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router